import * as React from 'react';
// import { RowFeedbackparameters, RowFeedbackTypes } from 'src/reducers/completeorderfile';
import ViewFeedbackPageView from '../layouts/viewFeedbackView';
import { Attachment, Param } from 'src/reducers/completeorderfile';

export interface ViewFeedbackPageProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    orderno: string;
    orderdate: string;
    completedon: string;
    tat: string;
    fname: string;
    tool_preferred: string;
    destination: string;
    modelonly: string;
    approval_reqd: string;
    bravopremium: string;
    nounits: string;
    fbtype: string;
    totalRating: number;
    comments: string;
    rca: string;
    actionplan: string;
    reviewstatus: string;
    attachments: Attachment[];
    params: Param[];
}

class ViewFeedbackPage extends React.Component<ViewFeedbackPageProps> {
    render() {
        return (
            <div>
                <ViewFeedbackPageView
                    totalRating={this.props.totalRating}
                    comments={this.props.comments}
                    fbtype={this.props.fbtype}
                    orderno={this.props.orderno}
                    orderdate={this.props.orderdate}
                    completedon={this.props.completedon}
                    tat={this.props.tat}
                    fname={this.props.fname}
                    tool_preferred={this.props.tool_preferred}
                    destination={this.props.destination}
                    modelonly={this.props.modelonly}
                    approval_reqd={this.props.approval_reqd}
                    bravopremium={this.props.bravopremium}
                    nounits={this.props.nounits}
                    rca={this.props.rca}
                    actionplan={this.props.actionplan}
                    reviewstatus={this.props.reviewstatus}
                    attachments={this.props.attachments}
                    params={this.props.params}
                />
            </div>
        );
    }
    componentDidMount() {
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default ViewFeedbackPage;



// WEBPACK FOOTER //
// ./src/components/feedback/viewFeedbackPage.tsx